import { render, staticRenderFns } from "./email-alert.vue?vue&type=template&id=7e3565a3&"
import script from "./email-alert.vue?vue&type=script&lang=js&"
export * from "./email-alert.vue?vue&type=script&lang=js&"
import style0 from "./email-alert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports